<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">IAB · Konzept</p>

      <h2 class="presentation-page__title">IAB-Nutzung für PV-Anlagen</h2>

      <p class="presentation-page__text">
        Wie aus dem Investitionsabzugsbetrag (§7g EStG) eine echte EK-Quelle für PV-Projekte wird.
      </p>

      <div class="presentation-page__group-cards presentation-page__group-cards--two">
        <article v-for="card in cards" :key="card.header" class="presentation-page__group-card">
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${card.accent}`,
            ]"
          >
            {{ card.header }}
          </div>

          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--detail"
          >
            <h3 class="presentation-page__group-card-title">{{ card.title }}</h3>
            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>
            <p class="presentation-page__group-card-text">{{ card.text }}</p>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Bis zu 50% Steuerminderung vor der Investition · §7g EStG · Drei-Jahres-Frist
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage29',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      cards: [
        {
          header: 'Grundlage',
          accent: 'brand-primary',
          title: 'Was ist der IAB?',
          text:
            'Der Investitionsabzugsbetrag nach §7g EStG erlaubt Unternehmen und Selbstständigen, bis zu 50% der geplanten Anschaffungskosten beweglicher Wirtschaftsgüter vorzeitig steuermindernd geltend zu machen — bis zu drei Jahre vor der eigentlichen Investition.',
        },
        {
          header: 'Anwendung',
          accent: 'brand-teal',
          title: 'Wie wir IABs für PV nutzen',
          text:
            'IABs können für die Eigenkapitalinvestition von Privatanlegern in PV-Anlagen verwendet werden. e way bietet ein IAB-PV-Anlagenmodell an, bei dem IABs auf physisch getrennte Teilbereiche der PV-Anlagen platziert werden — gemäß geltender rechtlicher Rahmenbedingungen.',
        },
      ],
    };
  },
};
</script>
